"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createIntegrationNameReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _IntegrationsAPI = require("reference-resolvers/api/IntegrationsAPI");

var createIntegrationNameReferenceResolver = function createIntegrationNameReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.INTEGRATION_NAMES,
    createFetchByIds: _IntegrationsAPI.createGetIntegrationNameByAppId,
    fetchByIds: _IntegrationsAPI.getIntegrationNameByAppId
  }, options));
};

exports.createIntegrationNameReferenceResolver = createIntegrationNameReferenceResolver;

var _default = createIntegrationNameReferenceResolver();

exports.default = _default;